import React from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { MockGrain, MockMetric } from "./LocationSummaryV2MockData";
import { v2Styles as styles } from "./LocationSummaryV2.styles";
import {
  ColumnWidths,
  getGrainLabel,
  SortState,
} from "./LocationSummaryV2Table.shared";

interface MetricColumn {
  key: MockMetric;
  label: string;
}

interface Props {
  grains: MockGrain[];
  metrics: readonly MetricColumn[];
  sort: SortState;
  columnWidths: ColumnWidths;
  onSort: (key: string) => void;
}

// Grains that receive a right-side divider border in their header and body cells.
// "region" is the always-visible default column and has no divider.
const BORDERED_GRAINS = new Set<MockGrain>([
  "market",
  "location",
  "locationType",
  "year",
  "period",
  "week",
]);

const LocationSummaryTableHeader: React.FC<Props> = ({
  grains,
  metrics,
  sort,
  columnWidths,
  onSort,
}) => {
  return (
    <View style={[styles.tableRow, styles.headerRow, { width: "100%" }]}>
      {grains.map((grain) => (
        <TouchableOpacity
          key={grain}
          style={[
            styles.cell,
            { width: columnWidths.grain },
            BORDERED_GRAINS.has(grain) && styles.columnDivider,
          ]}
          onPress={() => onSort(grain)}
        >
          <Text style={[styles.headerText, { textAlign: "left" }]}>
            {getGrainLabel(grain)}
            {sort.key === grain && (sort.desc ? " ↓" : " ↑")}
          </Text>
        </TouchableOpacity>
      ))}
      {metrics.map((metric) => (
        <TouchableOpacity
          key={metric.key}
          style={[
            {
              width: columnWidths.metric,
              paddingHorizontal: 8,
              paddingVertical: 4,
              justifyContent: "center",
            },
          ]}
          onPress={() => onSort(metric.key)}
        >
          <Text style={styles.headerText}>
            {metric.label}
            {sort.key === metric.key && (sort.desc ? " ↓" : " ↑")}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

export { BORDERED_GRAINS };
export default LocationSummaryTableHeader;
